/* eslint-disable no-lonely-if */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import _t from './translate';
import checkMetamask from './checkMetamask';
import login from './checkLogin';
import { getToken } from './login.js';

import createTeam from "./createTeam";
import {block, unblock} from "./blocker";
import {claimYoungPlayers} from "./api";
import showAlert from "./showAlert";

const createManager = async () => {
  console.log('createManager', createManager);

  // await checkMetamask();
  // if (!await login()) {
  //   return;
  // }

  const token = getToken();

  Swal.fire({
    title: _t('Hi Manager !'),
    html: `
        <br>
        <br>
          Create your manager profile and set up your team. <br> Choose a nickname:
          `,
    input: 'text',
    inputAttributes: {
      autocapitalize: 'off',
    },
    customClass: {
      popup: 'sw-long',
      cancelButton: 'order-1',
      confirmButton: 'order-2',
      denyButton: 'order-3',
    },
    inputValidator(inputValue) {
      if (!inputValue) {
        return 'Please enter your manager name';
      }
    },
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonText: _t('Save'),
    showLoaderOnConfirm: true,
    preConfirm: async (value) => {
      // const accounts = await web3Client.eth.getAccounts();
      // const address = accounts[0];
      const name = value;

      const msgData = {
        name,
        token,
        chainId: window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId,
        sessionKey: window.sessionKey,
      };

      $.post({
        url: '/api/team/createManager',
        headers: {
          token: window.token,
        },
        data: msgData,
        success: async (data) => {
          if (data.success) {

            createTeamN();
            // await Swal.fire(
            //   _t('Success!'),
            //   _t('Manager Created !'),
            //   'success',
            // );
            //
            // document.location.reload(true);
          } else {
            Swal.fire(
              _t('Error!'),
              data.message,
              'error',
            );
          }
        },
        error(xhr, status, error) {
          // handle error
        },
      });
    },
    allowOutsideClick: () => !Swal.isLoading(),
  });
};

function createTeamN()
{

  const token = getToken();

  Swal.fire({
    title: _t('Hi Manager !'),
    html: `
        <br>
        <br>
          Create your team
          `,
    input: 'text',
    inputAttributes: {
      autocapitalize: 'off',
    },
    customClass: {
      popup: 'sw-long',
      cancelButton: 'order-1',
      confirmButton: 'order-2',
      denyButton: 'order-3',
    },
    inputValidator(inputValue) {
      if (!inputValue) {
        return 'Please enter your team name';
      }
    },
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonText: _t('Save'),
    showLoaderOnConfirm: true,
    preConfirm: async (value) => {
      // const accounts = await web3Client.eth.getAccounts();
      // const address = accounts[0];
      const name = value;
      const msgData = {
        name,
        // address,
        // sessionKey: window.sessionKey,
        token: token,
      };

      $.post({
        url: '/api/team/createTeam',
        headers: {
          token: token,
        },
        data: msgData,
        success: async (data) => {
          if (data.success) {
            claimYoung();
           // document.location.reload(true);
          } else {
            Swal.fire(
              _t('Error!'),
              data.message,
              'error',
            );
          }
        },
        error(xhr, status, error) {
          // handle error
        },
      });
    },
    allowOutsideClick: () => !Swal.isLoading(),
  });

}

function claimYoung()
{
  const token = getToken();

  Swal.fire({
    title: _t('Young Players'),
    html: `<p style="margin-top: 90px" class="text-left">${_t(`If you have the right to request young players, the system will automatically generate 11 players for you. All of the players will be spawned with random abilities based on the positions in your current team formation..`)}</p>`,
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: _t('Sure!'),
    showLoaderOnConfirm: true,
    // allowOutsideClick: () => !Swal.isLoading(),
  }).then(async (result) => {
    block();
    if (result.isConfirmed) {
      const { message, success } = await claimYoungPlayers({
        data: {
          claim: 1,
          token: token,
          formationId: 1,
        },
      });
      if (success) {
        unblock();
      //  showAlert({ message, icon: 'success' });
        var url = window.location.href;
        url += '?claim=1&token=' + token;
        window.location.href = url;
      } else {
        unblock();
        showAlert({ message, icon: 'error' });
      }
    } else {
      unblock();
    }
  });

}
export default createManager;
